import { ChevronDownCircleIcon } from "lucide-react";

const MaintenanceSpecificationValueItem = (props: { label: string; value: string }) => {
  return (
    <div className="flex items-center gap-3">
      <div>
        <p className="italic font-light text-nowrap">
          {props.label}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <ChevronDownCircleIcon
          strokeWidth={1}
          className="text-white-300"
        />

        <div>
          <p className="font-bold">
            {props.value}
          </p>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceSpecificationValueItem;
